import React, { useState } from 'react';
import EmailAlertForm from 'Forms/EmailAlertForm';
import { sendProspectEmail } from 'Api/AccountApi';
import { trackEvent, TRACKING_ENUMS } from 'Utils/Analytics';
import { onSubmitReactFormError } from 'Utils/FormValidation';
import { useStore } from 'Hooks/useStore';
import { SectionSubTitle } from 'Components/Titles';
import { SmartLink } from 'Components/SmartLink';
import './EmailAlert.css';

const EmailAlert = ({ headline, ...props }) => {
  const {
    defaultConfig: { termsOfUsePage, privacyPolicyPage, prospectName },
  } = useStore('appConfig');
  const [submitted, setSubmitted] = useState(false);

  const trackSubmitEmailButtonClick = () => {
    trackEvent(TRACKING_ENUMS.EVENT_EMAIL_BUTTON_CLICKED, {
      page_item_title: headline,
      page_action_location: 'Splash Page Email Module',
      page_name: 'marketing landing',
      page_type: 'marketing landing',
    });
  };

  /**
   * Send a call to prospect service
   * @param { string }  email of the prospect
   */
  const handleFormSubmit = async ({ email }) => {
    const prospectResponse = await sendProspectEmail(email, window.location.href, prospectName);
    if (prospectResponse.status === 200 && prospectResponse.data.requestID) {
      setSubmitted(true);
      trackSubmitEmailButtonClick();
    } else {
      return onSubmitReactFormError('There was an issue processing your request. Please try again.');
    }
  };

  const className = ``;
  const { ctaText } = props;
  const ctaButtonText = ctaText.toLowerCase() || 'submit';

  const renderForm = () => {
    return (
      <div className="emailAlertFormContainer">
        <SectionSubTitle className="emailAlertTitle" text={headline} align="center" />
        <EmailAlertForm onFormSubmit={handleFormSubmit} ctaText={ctaText} />
        <div className="emailAlertDescription">
          {/**
           * following block code is temporarily hardcoded since DPP doesn't return urls
           * for privacy policy and TOU. When DPP can support the urls in marketing-email panel,
           * we will modify the following block code again.
           * ticket: https://fng-jira.fox.com/browse/DCGC-2085
           */}
          <span>By clicking &quot;{ctaButtonText}&quot;, you are agreeing to our </span>
          <SmartLink text="Privacy Policy" linkUrl={privacyPolicyPage} className="marketingEmailLink" reload />
          <span> and </span>
          <SmartLink text="Terms of Service" linkUrl={termsOfUsePage} className="marketingEmailLink" reload />
        </div>
      </div>
    );
  };

  const renderFormSuccess = () => (
    <div className={className}>
      <div className="emailAlertTitle">
        <div className="emailAlertHeader">Thank you, your email has successfully been submitted!</div>
      </div>
      <img
        className="emailSubmittedSuccessIcon"
        alt="successIcon"
        width="71"
        height="71"
        src="account/static/images/ic-circle-checkmark.svg"
      />
    </div>
  );

  return submitted ? renderFormSuccess() : renderForm();
};

export default EmailAlert;
